module.exports = require("@swa-ui/core/src/Input/Input.module.scss");